export enum PERSON_ORDER_COLUMNS {
  CPF = 'cpf',
  NAME = 'name',
  EMAIL = 'email',
}
